import React, { useContext, useEffect, useState } from "react";
import AppTable from "../table/AppTable";
import { useLazyQuery, useMutation } from "@apollo/client";
import {
  GET_MANAGE_TICKETS,
  GET_MANAGE_TICKETS_BY_LOGITIXUSER,
  GET_MANAGE_TICKETS_BY_SUPER_USER,
  RETURN_TICKET,
  VALIDATE_UPDATE,
} from "../../../features/Tickets/api/TicketsQuery";
import ToasterWithMessage from "../toaster";
import { globalContext } from "../../../Provider/AppProvider";
import { CircularProgress, Dialog } from "@mui/material";
import styles from '../../../features/Users/Users.module.css'
import PublishPopup from "../success-popup/PublishPopup";
import { CustomPaperComponent, roles } from "../../../helper";

const ManageTickets = (props: any) => {
  const {
    rowsPerPage,
    currentPage,
    setCurrentPage,
    checking,
    setChecking,
    manageTicketList,
    setManageTicketList,
    selected,
    setSelected,
    columnTypes,
    setColumnTypes,
    sortType,
    setSortType,
    GenerateManageTicketHeadCells,
    handleChangeRowsPerPage,
    handlePageChange,
    setSelectedTickets,
    selectedTickets
  } = props;

  const { error,success } = ToasterWithMessage();
  const [callApi , setCallApi] = useState(false)
  const {globalState,handleGlobalState} = useContext<any>(globalContext);
  const [searchvalue, setSearchvalue] = useState(globalState.globalSearch.searchtext);
  const StyledComponent = CustomPaperComponent();
  const [openDialogReturn, setOpenDialogReturn] = useState<boolean>(false);
  const [returnId, setReturnId] = useState<any>({});
  const isSuperUser = globalState.profile.userRole === roles.SUPER_USER;


  useEffect(() => {
    const tempdata = {...globalState}
    setSearchvalue(tempdata.globalSearch.searchtext)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [globalState.globalSearch.searchtext])

  //displayed the manage tickets in the table
  const [getManageTickets, {loading}] = useLazyQuery(GET_MANAGE_TICKETS , {
    fetchPolicy: "network-only",
    onCompleted: (data) => {
      setManageTicketList(data);
      const tempState = {...globalState};
      tempState.manageTicketFilter.clicked = false;
      tempState.manageTicketFilter.currentdate = Date.now();
      if(globalState.notification.notificationClicked){
      tempState.manageTicketFilter.notificationFilterDataCount = data?.filtermanagetickets_aggregate?.aggregate?.count;
      tempState.listTicketFilter.notificationFilterDataCount = data?.filterlisttickets_aggregate?.aggregate?.count;
      tempState.soldTicketFilter.notificationFilterDataCount = data?.FilterSoldTickets_aggregate?.aggregate?.count;
      tempState.delistAndReturnTicketFilter.notificationFilterDataCount = data?.filterreturntickets_aggregate?.aggregate?.count;
      tempState.unsoldTicketFilter.notificationFilterDataCount = data?.filterUnsoldTickets_aggreagate?.aggregate?.count;
      }if(globalState.error.errorClicked){
      tempState.manageTicketFilter.errorFilterDataCount = data?.filtermanagetickets_aggregate?.aggregate?.count;
      tempState.listTicketFilter.errorFilterDataCount = data?.filterlisttickets_aggregate?.aggregate?.count;
      tempState.soldTicketFilter.errorFilterDataCount = data?.FilterSoldTickets_aggregate?.aggregate?.count;
      tempState.delistAndReturnTicketFilter.errorFilterDataCount = data?.filterreturntickets_aggregate?.aggregate?.count;
      tempState.unsoldTicketFilter.errorFilterDataCount = data?.filterUnsoldTickets_aggreagate?.aggregate?.count;
      }
      handleGlobalState(tempState);
    },
    onError: () => {
      error("We’re having trouble connecting. Please clear your cache, refresh the page, and try again.");
    },
  });

  const [getManageTicketsByLogitix, {loading:logitixLoading}] = useLazyQuery(GET_MANAGE_TICKETS_BY_LOGITIXUSER, {
    fetchPolicy: "network-only",
    onCompleted: (dataForLogitix) => {
      setManageTicketList(dataForLogitix);
      const tempState = {...globalState};
      tempState.manageTicketFilter.clicked = false;
      tempState.manageTicketFilter.currentdate = Date.now();
      if(globalState.notification.notificationClicked){
      tempState.manageTicketFilter.notificationFilterDataCount = dataForLogitix?.filtermanagetickets_aggregate?.aggregate?.count;
      tempState.listTicketFilter.notificationFilterDataCount = dataForLogitix?.filterlisttickets_aggregate?.aggregate?.count;
      tempState.soldTicketFilter.notificationFilterDataCount = dataForLogitix?.FilterSoldTickets_aggregate?.aggregate?.count;
      tempState.delistAndReturnTicketFilter.notificationFilterDataCount = dataForLogitix?.filterreturntickets_aggregate?.aggregate?.count;
      tempState.unsoldTicketFilter.notificationFilterDataCount = dataForLogitix?.filterUnsoldTickets_aggreagate?.aggregate?.count;
      }if(globalState.error.errorClicked){
      tempState.manageTicketFilter.errorFilterDataCount = dataForLogitix?.filtermanagetickets_aggregate?.aggregate?.count;
      tempState.listTicketFilter.errorFilterDataCount = dataForLogitix?.filterlisttickets_aggregate?.aggregate?.count;
      tempState.soldTicketFilter.errorFilterDataCount = dataForLogitix?.FilterSoldTickets_aggregate?.aggregate?.count;
      tempState.delistAndReturnTicketFilter.errorFilterDataCount = dataForLogitix?.filterreturntickets_aggregate?.aggregate?.count;
      tempState.unsoldTicketFilter.errorFilterDataCount = dataForLogitix?.filterUnsoldTickets_aggreagate?.aggregate?.count;
      }
      handleGlobalState(tempState);
    },
    onError: () => {
      error("We’re having trouble connecting. Please clear your cache, refresh the page, and try again.");
    },
  });

  const [validateUpdate, {loading: validLoading}] = useMutation(VALIDATE_UPDATE, {
    fetchPolicy: "network-only",
    onCompleted: (data) => {
      if (data) {
         success("Updated successfully");
         setCallApi(true)
         setCurrentPage(1);
         const tempState = {...globalState};
         tempState.ticketUpdate.updatedticket = true;
         handleGlobalState(tempState)
      }
    },
    onError: (err) => {
      error(err?.message);
    },
  });
  const [returnTicketByAdmin] = useMutation(RETURN_TICKET,{
    fetchPolicy: 'no-cache',
    onCompleted: (data) =>{
      setColumnTypes('tp_updated_at')
      setSortType('desc')
      success("Ticket Returned Successfully")
      const tempState = {...globalState};
      tempState.ticketUpdate.returnTicket = true
      handleGlobalState(tempState);
    },
    onError: () =>{
      error('Unable to Return')
    }
  })
  useEffect(() => {
    if (globalState.notification.notificationClicked || globalState.error.errorClicked) {
      const getTicketsVariables={
        leagueId: null,
        ticketStatus: null,
        startdate: null,
        enddate: null,
        pageSize: rowsPerPage,
        pageOffset: (currentPage - 1) * rowsPerPage,
        order_by: [
          {[columnTypes]: sortType},
          {"tp_id": "asc"}
        ],
        day: null,
        ...( isSuperUser ? {u_id:globalState.profile.id } : {}),
        search_event: searchvalue === globalState.notification.text ? "%" : searchvalue === globalState.error.text ? "%" : `${searchvalue}%`,
        ticketId: globalState.notification.ticketId,
        tpId: globalState.notification.tpId,
        array_tpid:globalState?.notification.tp_id_array?globalState?.notification.tp_id_array:globalState?.error?.approximateTpArray?.length > 0 ? globalState.error.approximateTpArray : globalState.error.ticketPlacementId
      }
      if((globalState.profile.userRole===roles.ADMIN || globalState.profile.userRole===roles.AFFILIATER_ADMIN || globalState.profile.userRole === roles.SUPER_USER || globalState.profile.userRole === roles.USER)){
        getManageTickets({
            variables:getTicketsVariables,
        });
      }else if(globalState.profile.userRole==="logitix_user"){
        getManageTicketsByLogitix({
          variables: getTicketsVariables
      }); 
       }
    }
// eslint-disable-next-line react-hooks/exhaustive-deps
}, [globalState.notification.notificationClicked, globalState.error.errorClicked]);

  
  const callGetManageTicketsApi = () => {
    const manageTicketsVariables={
      leagueId: globalState?.notification?.notificationClicked ? null: globalState.manageTicketFilter.leagueId,
      ticketStatus: globalState?.notification?.notificationClicked ? null:  globalState.manageTicketFilter.validstatus,
      startdate: globalState?.notification?.notificationClicked ? null: globalState.manageTicketFilter.startdate ? globalState.manageTicketFilter.startdate : globalState.manageTicketFilter.startDateRange,
      enddate: globalState?.notification?.notificationClicked ? null: globalState.manageTicketFilter.enddate ? globalState.manageTicketFilter.enddate : globalState.manageTicketFilter.endDateRange,
      pageSize: rowsPerPage,
      pageOffset: (currentPage - 1) * rowsPerPage,
      ...( isSuperUser ? {u_id:globalState.profile.id } : {}),
      order_by: [
        {[columnTypes]: sortType},
        {"tp_id": "asc"}
      ],
      day: globalState?.notification?.notificationClicked ? null: globalState.manageTicketFilter.periodLeft,
      search_event:searchvalue === globalState.notification.text ?"%":searchvalue === globalState.error.text ?"%":`${searchvalue}%`,
      ticketId: globalState.notification.ticketId,
      tpId:globalState.notification.tpId,
      array_tpid: globalState?.notification.tp_id_array?globalState?.notification.tp_id_array:globalState?.error?.approximateTpArray?.length > 0 ? globalState.error.approximateTpArray : globalState.error.ticketPlacementId
    }
    if((globalState.profile.userRole===roles.ADMIN || globalState.profile.userRole===roles.AFFILIATER_ADMIN || isSuperUser || globalState.profile.userRole === roles.USER)){
    getManageTickets({
      variables: manageTicketsVariables
    });
  }else if(globalState.profile.userRole === "logitix_user"){
    getManageTicketsByLogitix({
      variables:manageTicketsVariables
    });
  }
  }

  useEffect(() => {
      callGetManageTicketsApi();
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [globalState.globalSearch.searchtext,searchvalue,globalState.markAsSoldTicket.manangeTicketCalled]);


    useEffect(()=>{
      callGetManageTicketsApi();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[globalState?.markAsSoldTicket?.markAsSold])

  useEffect(() => {
  if(globalState.ticketUpdate.updatedticket || globalState.ticketUpdate.returnTicket){
    callGetManageTicketsApi();
  }
  const tempState = {...globalState};
  tempState.ticketUpdate.updatedticket = false;
  tempState.ticketUpdate.returnTicket = false;
  handleGlobalState(tempState)
  
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [globalState.ticketUpdate.updatedticket,globalState.ticketUpdate.returnTicket]);

  useEffect(() =>{
    if(globalState.publishticket.publish){
      callGetManageTicketsApi();
    }
    const tempState = {...globalState};
    tempState.publishticket.publish = false
    tempState.publishticket.publishBulk = false
    handleGlobalState(tempState)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[globalState.publishticket.publish])

  useEffect(() =>{
    if(globalState.publishBulkticket.publishBulk){
      callGetManageTicketsApi();
    }
    const tempState = {...globalState};
    tempState.publishBulkticket.publishBulk = false
    handleGlobalState(tempState)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[globalState.publishBulkticket.publishBulk])


  useEffect(() => {
    if(globalState.manageTicketFilter.clicked){
    callGetManageTicketsApi();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
      globalState.manageTicketFilter.clicked
    ]);

    useEffect(() => {
        callGetManageTicketsApi();
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [rowsPerPage,
        currentPage,
        sortType, 
        columnTypes,
        callApi, 
        setCallApi,
        globalState.notification.notificationSearchCancel
      ]);
  const [selectedValues, setSelectedValues] = useState<string[]>([]);


  const handleOpenDialogReturn = (rowId:string) =>{
    setOpenDialogReturn(true)
    setReturnId(rowId);
   }
  const handleCloseDialogReturn = () =>{
    setOpenDialogReturn(false)
  }
  const handleAllowReturn = (event : React.MouseEvent<HTMLButtonElement>) =>{
    event.preventDefault()
    if(event){
      setOpenDialogReturn(false)
        returnTicketByAdmin({
          variables:{
            ticketPlacementId: [returnId]
          }
        })
      }
    }

  // Function to handle dropdown changes for a specific index
  const handleDropdownChange = (e: any, index: number, rowid: string) => {
    let value;
    if(e.target.value === "ToBeVerified") {
      validateUpdate({
        variables: {
          isUndoRequest: true,
          ticketPlacementId: [rowid],
        },
      });
    } else {
      e.target.value === "valid" ? (value = true) : (value = false);
      const newSelectedValues = [...selectedValues];
      newSelectedValues[index] = e.target.value;
      setSelectedValues(newSelectedValues);
      setColumnTypes("tp_updated_at");
      setSortType("desc");
      if(e.target.value === "return"){
        handleOpenDialogReturn(rowid);
      }else{
        validateUpdate({
          variables: {
            isValid: value,
            ticketPlacementId: [rowid],
          },
        });
      }
    }
    setSelectedValues([])
  };


  return (
    <>
            {
              (loading || validLoading||logitixLoading)
            ? 
              <div className={styles.TableCircularProgress}>
              <CircularProgress color="primary" size={35} />
              </div>
            :
              <AppTable
                handleChangeRowsPerPage={handleChangeRowsPerPage}
                handlePageChange={handlePageChange}
                setColumnTypes={setColumnTypes}
                sortType={sortType}
                setSortType={setSortType}
                setSelected={setSelected}
                setChecking={setChecking}
                checking={checking}
                selected={selected}
                rowsPerPage={rowsPerPage}
                setCurrentPage={setCurrentPage}
                currentPage={currentPage}
                list={manageTicketList}
                tableTitle="managetickets"
                generateHeadCells={GenerateManageTicketHeadCells}
                selectedTickets={selectedTickets}
                setSelectedTickets={setSelectedTickets}
                handleDropdownChange={handleDropdownChange}
                selectedValues={selectedValues}
                setSelectedValues={setSelectedValues}
              />
            }
            <Dialog
                open={openDialogReturn}
                PaperComponent={StyledComponent}
              >
              <PublishPopup title="Return?" subTitle="Kindly confirm - Once you returned the ticket to the sender" returnTicket={true} handleAllow={handleAllowReturn} handleClose={handleCloseDialogReturn}/>
              </Dialog>
    </>
  );
};

export default ManageTickets;
